import { search } from "../BaseRepositoryComponents";

const baseUrl = process.env.REACT_APP_NEW_PAINEL_API_URL;

export function getEntityInstances(document) {
  return search({
    path: `${baseUrl}/v1/conectazap/instances/${document}`,
    method: "GET",
  });
}

export function addNewInstance(document) {
  return search({
    path: `${baseUrl}/v1/conectazap/instances`,
    method: "POST",
    myBody: {
      company_document: document,
    },
  });
}

export function getQrCode(document, instanceId) {
  return search({
    path: `${baseUrl}/v1/conectazap/instances/${document}/qrcode/${instanceId}`,
    method: "GET",
    showMessage: false,
  });
  // return "vaitomanocu";
}

export function disconnectPhoneFromInstance(document, instanceId) {
  return search({
    path: `${baseUrl}/v1/conectazap/instances/${document}/disconnect/${instanceId}`,
    method: "GET",
  });
}

export function updatePhoneUsage(document, phoneNumberId, typeUsage, value) {
  let body = {
    type_usage: typeUsage,
    value: value,
  };

  if (value) {
    body["phone_number_id"] = phoneNumberId;
  }
  return search({
    path: `${baseUrl}/v1/conectazap/instances/${document}/phone`,
    method: "PUT",
    myBody: body,
  });
}

// NOT USED CODE
// export const deleteInstance = (document, instanceId) => {
//   return search({
//     path: `${baseUrl}/v1/conectazap/instances`,
//     method: "DELETE",
//     myBody: {
//       company_document: document,
//       instance_id: instanceId,
//     },
//   });
// };

export const getNumbersBlocked = (document) => {
  return search({
    path: `${baseUrl}/v1/conectazap/instances/${document}/blocked-numbers`,
    method: "GET",
  });
};

export const removeNumberBlocked = (document, number) => {
  return search({
    path: `${baseUrl}/v1/conectazap/instances/${document}/blocked-numbers`,
    method: "DELETE",
    myBody: {
      number: number,
    },
  });
};

export const getDefaultMessages = (document) => {
  return search({
    path: `${baseUrl}/v1/conectazap/instances/${document}/default-messages`,
    method: "GET",
  });
};

export const updateDefaultMessages = (document, key, message) => {
  return search({
    path: `${baseUrl}/v1/conectazap/instances/${document}/default-messages`,
    method: "PUT",
    myBody: {
      key: key,
      message: message,
    },
  });
};

export const resetDefaultMessages = (document, key) => {
  return search({
    path: `${baseUrl}/v1/conectazap/instances/${document}/default-messages/reset`,
    method: "POST",
    myBody: {
      key: key,
    },
  });
};
